import React from 'react'
import PropTypes from 'prop-types'
import NRTFormInput from '../../../../../_common/_form/FormInput'
import { Validators } from '../../../../../_common/_form/Validators'

const QuestionTrueOrFalse = (props) => {
    const code = props.code
    const answer = {...props.answer} 
    const disabled = props.isReview
 //   console.log(`TorF`, answer)
    return (
        <div className={'nrt-ead-question-truefalse'}>
            {
                props.optionDTOs.sort((a,b) => a.order - b.order).map((option) => {

                    return (
                        <div
                            key={props.code +'.' + option.code }
                            style={{
                            marginBottom: '1rem'
                        }}>

                            <p>{option.text}</p>

                            <NRTFormInput
                                name={code +'.' + option.code}
                                type={'radiogroup'}
                                value={answer && answer[option.code]}
                                disabled={disabled}
                                validators={[
                                    Validators.required()
                                ]}
                                customProps={{
                                    style: {
                                        display: 'flex'
                                    },
                                    options: [
                                        {
                                            display: 'Verdadeiro',
                                            value: true,
                                        },
                                        {
                                            display: 'Falso',
                                            value: false,
                                        }
                                    ]
                                }}
                            />
                        </div>
                    )
                })
            }
        </div>
    )
}

QuestionTrueOrFalse.propTypes = {
    id: PropTypes.string.isRequired  ,
    statements: PropTypes.arrayOf(PropTypes.string)
}

QuestionTrueOrFalse.defaultProps = {}

export default QuestionTrueOrFalse



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/QuestionsNew/_components/Questions/QuestionTrueOrFalse.js